// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .open, .closed{
    width: -moz-available !important;          /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available !important;  /* Mozilla-based browsers will ignore this. */
    width: fill-available !important;
  }
  .containerPanel{
    background: #fff;
    padding: 16px;
  }
  .formContainer {
    min-width: 258px;
    min-height: 642px;
    padding: 16px;
    background: #fff;
}

.formContainerInner {
    height: 100%;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #D6DCEB;
    margin-bottom: 20px;
}
.formTitle {
    font-size: 10px;
    font-weight: 800;
    line-height: 14px;
    margin-top: -30px;
    color: #666666 !important;
    position: relative;
    background-color: white;
    padding: 6px;
    padding-left: 0;
    width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/adminCore/collect/assets/style.css"],"names":[],"mappings":"EAAE;IACE,gCAAgC,WAAW,4CAA4C;IACvF,wCAAwC,GAAG,6CAA6C;IACxF,gCAAgC;EAClC;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["  .open, .closed{\r\n    width: -moz-available !important;          /* WebKit-based browsers will ignore this. */\r\n    width: -webkit-fill-available !important;  /* Mozilla-based browsers will ignore this. */\r\n    width: fill-available !important;\r\n  }\r\n  .containerPanel{\r\n    background: #fff;\r\n    padding: 16px;\r\n  }\r\n  .formContainer {\r\n    min-width: 258px;\r\n    min-height: 642px;\r\n    padding: 16px;\r\n    background: #fff;\r\n}\r\n\r\n.formContainerInner {\r\n    height: 100%;\r\n    padding: 16px;\r\n    border-radius: 4px;\r\n    border: 1px solid #D6DCEB;\r\n    margin-bottom: 20px;\r\n}\r\n.formTitle {\r\n    font-size: 10px;\r\n    font-weight: 800;\r\n    line-height: 14px;\r\n    margin-top: -30px;\r\n    color: #666666 !important;\r\n    position: relative;\r\n    background-color: white;\r\n    padding: 6px;\r\n    padding-left: 0;\r\n    width: fit-content;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
